import { useMutation, useQuery, useQueryClient } from "react-query";
import { ChargeUserPayload, TransactionService } from "./transaction.service";
import toast from "react-hot-toast";
import { getErrorMessage } from "../../utils/string";

export const useTransactions = (page: number, option?: Object) => {
  return useQuery(
    ["list_transaction", page, option],
    async () => {
      const { data } = await TransactionService.getAll({ page, ...option });
      return data;
    },
    { keepPreviousData: true },
  );
};

export const useGetTransactionDetail = (id: string) =>
  useQuery(
    ["transaction_detail", id],
    () => TransactionService.getDetail(id),
    {
      enabled: !!id,
      onError: (error: any) => {
        toast.error(getErrorMessage(error, "Failed to load transaction details"));
      },
    }
  );

export const useDeleteTransaction = () => {
  const queryClient = useQueryClient();

  return useMutation(
    async ({
      transactionId,
      reasonDelete,
    }: {
      transactionId: string;
      reasonDelete: string;
    }) => {
      return TransactionService.deleteTransaction(
        transactionId,
        reasonDelete,
      );
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(["list_transaction"]);
        queryClient.invalidateQueries(["transaction_detail"]);
      },
    },
  );
};
export const useChargeUser = (callback?: (data: any) => void) => {
  const queryClient = useQueryClient();
  return useMutation(
    async (payload: ChargeUserPayload) => {
      const data = await TransactionService.chargeUser(payload);
      return data;
    },
    {
      onSuccess: (data) => {
        if (data.ok) {
          toast.success(data.msg || "Successfully!");
          queryClient.invalidateQueries(['list_transaction']);
          queryClient.invalidateQueries(['listSession']);
          callback?.(data);
        } else {
          toast.error(getErrorMessage(data));
        }
      },
      onError: (error: any) => {
        toast.error(getErrorMessage(error));
      },
    }
  );
};
